export const getToken = () => {
	if (window.localStorage) {
		let token = window.localStorage.getItem("token");
		return token || null;
	}
	return null;
};
